import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleDateChangeEvent, handlePatch } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import ErrorAwareYearPicker from '../../../../common/inputfields/ErrorAwareYearPicker';

class ModifyAvailableDividend extends Component {
    state = {
        year: new Date(this.props.row.year, 0, 1),
        amount: this.props.row.amount,
        availableFrom: new Date(this.props.row.availableFrom),
        availableUntil: new Date(this.props.row.availableUntil),
        comment: this.props.row.comment,
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/availabledividend';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "year": this.state.year.getFullYear(),
            "amount": util.toNumber(this.state.amount),
            "availableFrom": this.state.availableFrom,
            "availableUntil": this.state.availableUntil,
            "comment": this.state.comment,
        };

        handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareYearPicker
                            required
                            name="year"
                            label="Év"
                            errors={this.state.errors}
                            value={this.state.year}
                            prevValue={new Date(this.props.row.year, 0, 1)}
                            onChange={e => handleDateChangeEvent(e, "year", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="amount"
                            name="amount"
                            label="Összeg"
                            errors={this.state.errors}
                            value={this.state.amount}
                            prevValue={this.props.row.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="availableFrom"
                            label="Mikortól"
                            errors={this.state.errors}
                            value={this.state.availableFrom}
                            prevValue={new Date(this.props.row.availableFrom)}
                            onChange={e => handleDateChangeEvent(e, "availableFrom", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="availableUntil"
                            label="Meddig"
                            errors={this.state.errors}
                            value={this.state.availableUntil}
                            prevValue={new Date(this.props.row.availableUntil)}
                            onChange={e => handleDateChangeEvent(e, "availableUntil", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyAvailableDividend);
